export default "__VITE_ASSET__BOiPp11q__"